import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useHistory, useParams } from "react-router-dom";

import { View } from "../storage/routes";

import { getAsset, getAssetStream, getAssetTitle } from "../services/asset";
import VideoJS from "../Components/VideoJS";

import "./Player.scss";
import {
  displayUI, forceUI,
  hideUI,
} from '../storage/emitter'
import { fade } from "../storage/motionAnimations";
import { useUIShown } from "../storage/hooks";

const Player = () => {
  const isUIShown = useUIShown();
  const history = useHistory();
  const { partner, id: assetID } = useParams();
  const player = useRef(null);
  const [asset, setAsset] = useState(null);

  const videoJsOptions = useMemo(() => {
    if (!asset) return {};
    const stream = getAssetStream(asset);
    return {
      // lookup the options in the docs for more options
      autoplay: true,
      controls: true,
      responsive: true,
      // fluid: true,
      fill: true,
      // inactivityTimeout: 0,
      controlBar: {
        fullscreenToggle: false,
        volumePanel: false,
      },
      sources: [
        {
          src: stream.source,
          type: stream.mimeType,
        },
      ],
    };
  }, [asset]);

  const onEnded = useCallback(() => {
    displayUI();
    history.goBack();
  }, [history]);

  const onUserActive = useCallback(
    (event) => {
      displayUI();
      forceUI(false);
    },
    []
  );
  const onUserInactive = useCallback(
    (event) => {
      forceUI(false);
      if (!player.current.paused) hideUI();
    },
    []
  );

  useEffect(() => {
    getAsset(partner, assetID).then((asset) => {
      setAsset(asset);
    });
  }, [partner, assetID]);

  return (
    <View style={{ height: "100%" }}>
      <div id="player-view">
        {asset && (
          <>
            <AnimatePresence
              initial={false}
              exitBeforeEnter={true}
              onExitComplete={() => null}
            >
              {isUIShown && (
                <motion.div
                  variants={fade}
                  initial="visible"
                  animate="visible"
                  exit="exit"
                >
                  <div className="back-button" onClick={onEnded} />
                  <div className="player-title">{getAssetTitle(asset)}</div>
                </motion.div>
              )}
            </AnimatePresence>
            <VideoJS
              ref={player}
              options={videoJsOptions}
              onEnded={onEnded}
              onUserActive={onUserActive}
              onUserInactive={onUserInactive}
            />
          </>
        )}
      </div>
    </View>
  );
};

export default Player;
